import React, { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/authContext/authContext";
import MUIDataTable from "mui-datatables";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan, faTruck } from "@fortawesome/free-solid-svg-icons";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useUnidades } from "../../hooks/test/useUnidades";
import Select from "react-select";
import Swal from "sweetalert2";

const initialStateFormFormatoSalida = {
  idunidad: "",
  unidad: "",
  idunidadCaja: "",
  unidadCaja: "",
  chofer_id: "",
  tripulacion: [],
  cajas: [],
};

export const ProgramarViajesAutomaticos = () => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const { user } = useContext(AuthContext);
  const [data, setData] = useState([]);
  const [listoperadores, setListOperadores] = useState([]);
  const [listtripulantes, setListTripulantes] = useState([]);
  const [listUnidadesByHub, setUnidadesByHub] = useState([]);
  const [listUnidadesCaja, setUnidadesCaja] = useState([]);
  const [form, setForm] = useState(initialStateFormFormatoSalida);
  const { idunidad, unidad, idunidadCaja, unidadCaja, cajas, chofer_id, tripulacion } = form;
  const [isChecked, setIsChecked] = useState(false);

  const {
    getListViajesAutomaticos,
    getListTripulantesByHub,
    postViajesAutomaticos,
    putReasignarUnidad,
    getUnits,
    getUnitsBusqueda,
    postTripulantes,
    getunidadesNegocio,
    postViajesAutomaticosV2,
  } = useUnidades();

  const columns = ["Unidad", "Operador", "Tripulación", "Acciones"];

  useEffect(() => {
    listunidades();
    loadInfo();
  }, []);

  const loadInfo = async () => {
    let listOp = await getListTripulantesByHub(user.cedis_id, 1);
    let listTri = await getListTripulantesByHub(user.cedis_id, 2);
    let listUnidades = await getUnits();
    let listUnidadesCajas = await getunidadesNegocio(user.negocio_id, 7);

    if (listOp.ok) {
      setListOperadores(listOp.tripulante);
    }
    if (listTri.ok) {
      setListTripulantes(listTri.tripulante);
    }

    if (listUnidades.ok) {
      setUnidadesByHub(listUnidades.unidades)
    }

    if (listUnidadesCajas.ok) {
      setUnidadesCaja(listUnidadesCajas.unidades)
    }

  };


  const asignarUnidad = () => {
    handleShow();
  }

  const listunidades = async () => {
    let resp = await getListViajesAutomaticos(user.cedis_id);
    if (resp.ok) {
      let array = [];
      let tri1 = "";
      let tri2 = "";
      resp.viajesAutomaticos.map(
        ({
          unidad_id,
          unidad,
          operador,
          tripulante1,
          tripulante2,
        }) => {
          tripulante1 != null
            ? (tri1 = tripulante1.nombre_completo)
            : (tri1 = "");
          tripulante2 != null
            ? (tri2 = tripulante2.nombre_completo)
            : (tri2 = "");

          let aux = [
            unidad.unidad_numero,
            operador.nombre_completo,
            tri2 !== "" ? tri1 + ", " + tri2 : tri1 !== "" ? tri1 : "",
            <>
              <FontAwesomeIcon
                icon={faTrashCan}
                className="fa-2x text-secondary"
                title="Asignar unidad"
                onClick={() => (reasignarUnidad(unidad_id))}
              />
            </>,
          ];
          array.push(aux);
          return "";
        }
      );
      setData([...array]);
    }
    // if (!resp.ok) {
    //   setData([]);
    // }
  };

  const options = {
    selectableRows: "none",
    downloadOptions: {
      filename: "asiganacionUnidades.csv",
      // separator: ";",
      filterOptions: {
        useDisplayedColumnsOnly: true,
        useDisplayedRowsOnly: true,
      },
      CharacterData: "utf-8",
      CharSet: "utf-8",
    },
    onDownload: (buildHead, buildBody, columns, data) => {
      return "\uFEFF" + buildHead(columns) + buildBody(data);
    },
    textLabels: {
      body: {
        noMatch: "No se encontraron registros",
        toolTip: "Ordenar",
        columnHeaderTooltip: (column) => `Ordenar por ${column.label}`,
      },
      pagination: {
        next: "Página siguiente",
        previous: "Página anterior",
        rowsPerPage: "Filas por página:",
        displayRows: "de",
      },
      toolbar: {
        search: "Buscar",
        downloadCsv: "Descargar CSV",
        print: "Imprimir",
        viewColumns: "Ver columnas",
        filterTable: "Filtro de tabla",
      },
      filter: {
        all: "TODOS",
        title: "FILTROS",
        reset: "LIMPIAR",
      },
      viewColumns: {
        title: "Mostrar columnas",
        titleAria: "Mostrar/Ocultar columnas de tabla",
      },
      selectedRows: {
        text: "Fila(s) seleccionada(s)",
        delete: "Remover",
        deleteAria: "Fila seleccionada removida",
      },
    },
  };

  const handleChange = (event) => {
    setForm({
      ...form,
      [event.target.name]:
        typeof event.target.value === "string"
          ? event.target.value.toUpperCase()
          : event.target.value,
    });
  };

  const pintarChofer = () => {
    let find = listoperadores.find(
      (x) => x.disponible === 1 && x.tripulante_id === form.chofer_id
    );
    if (find)
      return (
        <>
          <h6 className="mb-1">Operador</h6>
          <h5 className="text-warning pintaroperador">
            {find.nombre_completo} - {find.telefono}
          </h5>
        </>
      );
    return (
      <>
        <h6 className="mb-1">Operador</h6>
        <h5 className="text-warning pintaroperador">Sin operador</h5>
      </>
    );
  };

  const pintarTripulante = (tripulante_id) => {
    let find = listtripulantes.find(
      (x) => x.disponible === 1 && x.tripulante_id === tripulante_id
    );

    if (find)
      return (
        <>
          <h5 className="text-warning" key={tripulante_id}>
            <i

              className="fa-solid fa-circle-minus text-danger ml-3"
              onClick={() => {
                let arrayTripulacion = [...tripulacion];
                let index = arrayTripulacion.findIndex(
                  (x) => x.tripulante_id === tripulante_id
                );
                if (index >= 0) {
                  arrayTripulacion.splice(index, 1);
                  if (arrayTripulacion.length === 0);
                  return handleChange({
                    target: {
                      name: "tripulacion",
                      value: arrayTripulacion,
                    },
                  });
                }
              }}
            ></i>{" "}
            {find.nombre_completo} - {find.telefono}
          </h5>
        </>
      );
    return (
      <>
        <h5 className="text-warning">Sin tripulante</h5>
      </>
    );
  };

  const registrarAsignarUnidad = async () => {
    let resp = await postViajesAutomaticosV2({
      unidad_id: idunidad,
      operador_id: chofer_id,
      tripulantes: tripulacion.map(x => x.tripulante_id),
      evento_id: 36,
      cedis_id: user.cedis_id,
      cajas: cajas.map(c => c.caja_id),
    });

    if (resp.ok) {
      handleClose();

      Swal.fire({
        icon: "success",
        title: "!Unidad asignada correctamente¡",
        showConfirmButton: false,
        timer: 1500,
      });
      limpiarDatos();
      listunidades();
      loadInfo();
    } else {
      Swal.fire({
        icon: "error",
        title: resp.msg ? resp.msg : "Error al asignar unidad favor de intentarlo nuevamente",
        showConfirmButton: true,
        confirmButtonText: "OK",
      });
    }
  };

  const limpiarDatos = () => {
    setForm(initialStateFormFormatoSalida);
    setIsChecked(false);
  }

  const reasignarUnidad = async (unidadId) => {

    Swal
      .fire({
        title: "¡Seguro que deseas eliminar la asignación",
        text: "¿Confirmar?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: "Sí",
        cancelButtonText: "Cancelar",
      })
      .then(async resultado => {
        if (resultado.value) {

          let resp = await putReasignarUnidad(unidadId);
          if (resp.ok) {

            listunidades();
            loadInfo();

            return Swal.fire({
              icon: "success",
              title: resp.msg,
              showConfirmButton: false,
              timer: 1500,
            });

          } else {
            Swal.fire({
              icon: "error",
              title: resp.msg,
              confirmButtonText: "OK",
              showConfirmButton: true,
            });
          }

        } else {
          // Dijeron que no
          console.log("*NO se hace nada*");
        }
      });

  }

  return (
    <>
      <div className="container">
        <div id="viajesAutomaticos" className="row">

          <div className="col-12">
            <button className="btnasignarunidad" data-bs-toggle="modal" data-bs-target="#asignarUnidadModal" >
              <FontAwesomeIcon
                icon={faTruck}
                className="fa-2x text-secondary iconasignarunidad"
                title="Asignar unidad"
              />
            </button>
          </div>

          <MUIDataTable
            title={"ASIGNACIÓN DE UNIDADES"}
            data={data}
            columns={columns}
            options={options}
            onDownload={(buildHead, buildBody, columns, data) => {
              return "\uFEFF" + buildHead(columns) + buildBody(data);
            }}
          />
        </div>
      </div>
      <div
        className="modal fade"
        id="asignarUnidadModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="asignarUnidadModalLabel"
        data-bs-focus="false"
        aria-hidden="true">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <p id="tituloModal" className="text-center">
                Asignación de operador y tripulación
              </p>
            </div>
            <div className="modal-body">
              <Select
                options={listUnidadesByHub.map((listunidad) => {

                  return {
                    value: listunidad.unidad_id,
                    isDisabled: listunidad.unidad_disponible ? false : true,
                    label: `${listunidad.unidad_numero} ${!listunidad.unidad_disponible ? "(No disponible)" : ""} ${listunidad.baja ? "(Deshabilitado)" : ""}`,
                  }
                })}
                id="selectOperador"
                className="mb-2 form-control"
                classNamePrefix={"select"}
                name="chofer_id"
                value={
                  idunidad
                    ? listUnidadesByHub
                      .map(u => ({ value: u.unidad_id, label: u.unidad_numero }))
                      .find(o => o.value === idunidad) ?? null
                    : null
                }
                onChange={(elemento) => {
                  setForm({
                    ...form,
                    idunidad: elemento.value,
                    unidad: elemento.label,
                  });
                }}
                placeholder="Selecciona unidad"
              />
              <h6 className="mb-1">Unidad<p className="text-warning">{unidad}</p></h6>

              <div className="col-12 mb-3">
                <div className="d-flex justify-content-center">
                  <input
                    type="checkbox"
                    className="form-check-input mb-2"
                    checked={isChecked}
                    onChange={(event) => {
                      setIsChecked(event.target.checked);
                      if (event.target.checked)
                        handleChange({
                          target: {
                            name: "tripulacion",
                            value: [],
                          },
                        });
                      if (!event.target.checked) {
                        setForm(prev => ({ ...prev, cajas: [] }));
                      }
                    }}
                  ></input>
                  <label className="ps-2 mt-1">
                    ASIGNAR CAJA SECA
                  </label>
                </div>
              </div>


              {
                isChecked && (
                  <>
                    <Select
                      options={listUnidadesCaja.map((listunidad) => {

                        return {
                          value: listunidad.unidad_id,
                          isDisabled: listunidad.unidad_disponible ? false : true,
                          label: `${listunidad.unidad_numero} ${!listunidad.unidad_disponible ? "(No disponible)" : ""} ${listunidad.baja ? "(Deshabilitado)" : ""}`,
                        }
                      })}
                      className="mb-2 form-control"
                      classNamePrefix={"select"}
                      name="unidadCaja"
                      onChange={(elemento) => {
                        if (cajas.length >= 2)
                          return Swal.fire({
                            title: "No es posible agregar más cajas",
                            text: "Solo puedes agregar máximo 2 cajas",
                            icon: "warning",
                          });

                        const yaExiste = cajas.find(c => c.caja_id === elemento.value);
                        if (yaExiste) return;

                        setForm(prev => ({
                          ...prev,
                          cajas: [...prev.cajas, { caja_id: elemento.value, label: elemento.label }],
                        }));
                      }}
                      value={null}
                      placeholder="Selecciona caja seca"
                    />

                    <h6 className="mb-1">Caja seca<p className="text-warning">{unidadCaja}</p></h6>

                    {cajas.map((c) => (
                      <h5 key={c.caja_id} className="text-warning" style={{textAlign: "center"}}>
                        <i
                          className="fa-solid fa-circle-minus text-danger ml-3"
                          onClick={() =>
                            setForm(prev => ({
                              ...prev,
                              cajas: prev.cajas.filter(x => x.caja_id !== c.caja_id),
                            }))
                          }
                        />
                        {" "}{c.label}
                      </h5>
                    ))}
                  </>
                )
              }

              <Select
                options={listoperadores.map((chofer) => {
                  if (chofer.disponible === 1)
                    return {
                      value: chofer.tripulante_id,
                      isDisabled: !chofer.ocupado ? false : true,
                      label: `${chofer.nombre_completo} ${chofer.telefono}`,
                    };
                  return "";
                })}
                id="selectOperador"
                className="mb-2 form-control"
                classNamePrefix={"select"}
                name="chofer_id"
                value={
                  chofer_id
                    ? listoperadores
                      .map(c => ({ value: c.tripulante_id, label: `${c.nombre_completo} ${c.telefono}` }))
                      .find(o => o.value === chofer_id) ?? null
                    : null
                }
                onChange={(elemento) => {
                  setForm({ ...form, chofer_id: elemento.value });
                }}
                placeholder="Selecciona operador"
                noOptionsMessage={() => (
                  <button
                    className="btn"
                    onClick={() =>
                      Swal.fire({
                        title: "Ingresa los datos del operador a crear.",
                        showCancelButton: true,
                        confirmButtonText: "Registrar",
                        showLoaderOnConfirm: true,
                        html: `
                                <label>Nombre completo</label>
                                <input type="text" id="nombre_completo" class="form-control" placeholder="Nombre completo">
                                <label>Teléfono</label>
                                <input type="number" id="telefono" class="form-control" placeholder="Teléfono">`,
                        preConfirm: () => {
                          const nombre_completo =
                            Swal.getPopup().querySelector("#nombre_completo").value;
                          const telefono =
                            Swal.getPopup().querySelector("#telefono").value;
                          if (!nombre_completo || !telefono) {
                            Swal.showValidationMessage(
                              `Por favor registra el nombre y el teléfono`
                            );
                          }
                          return { nombre_completo, telefono };
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                      }).then(async (result) => {
                        if (!result.value) return;
                        const { nombre_completo, telefono } = result.value;
                        if (result.isConfirmed) {
                          if (telefono.length !== 10) {
                            return Swal.fire({
                              title: "No se puede crear el registro",
                              text: "Debe ser 10 digitos el telefono",
                              icon: "error",
                            });
                          }
                          // let resp = await postChofer({
                          //   nombre_completo,
                          //   telefono,
                          //   disponible: 1,
                          //   negocio_id: 1,
                          //   cedis_id: user.cedis_id,
                          // });

                          let resp = await postTripulantes({
                            "nombre_completo": nombre_completo,
                            "telefono": telefono,
                            "cedis_id": user.cedis_id,
                            "tipo_tripulante_id": 1,
                            "negocio_id": user.negocio_id,
                          });

                          if (resp.tripulante_id) {
                            setForm({
                              ...form,
                              chofer_id: resp.tripulante_id,
                            });
                            let resp1 = await getListTripulantesByHub(
                              user.cedis_id,
                              1
                            );

                            if (resp1.ok) {
                              setListOperadores(resp1.tripulante);
                            } else {
                              setListOperadores([]);
                            }
                            return Swal.fire({
                              title: `Chofer creado con éxito`,
                              text: resp.msg,
                              icon: "success",
                            });
                          }
                          return Swal.fire({
                            title: `No se pudo crear el chofer`,
                            text: resp.msg,
                            icon: "error",
                          });
                        }
                      })
                    }
                  >
                    Registrar operador
                  </button>
                )}
              />
              <div className="col-12">{pintarChofer()}</div>
              <br />
              <Select
                id="selectTripulacion"
                className="form-control"
                classNamePrefix={"select"}
                name="chofer_id"
                value={null}
                placeholder="Selecciona tripulante"
                options={listtripulantes.map((x) => {
                  let find = tripulacion.find(
                    (y) => y.tripulante_id === x.tripulante_id
                  );

                  return {
                    value: x.tripulante_id,
                    label: `${x.nombre_completo} ${x.telefono}`,
                    isDisabled: find || x.ocupado ? true : false,
                  };
                })}
                onChange={(elemento) => {
                  if (tripulacion.length > 1)
                    return Swal.fire({
                      title: "No es posible agregar más tripulantes",
                      text: "Solo puedes agregar máximo 2 tripulantes",
                      icon: "warning",
                    });
                  const arrayTripulacion = [...tripulacion];
                  arrayTripulacion.push({
                    tripulante_id: Math.floor(elemento.value),
                  });

                  handleChange({
                    target: {
                      name: "tripulacion",
                      value: arrayTripulacion,
                    },
                  });
                }}
                noOptionsMessage={() => (
                  <button
                    className="btn"
                    onClick={() =>
                      Swal.fire({
                        title: "Ingresa los datos del tripulante a registrar.",
                        showCancelButton: true,
                        confirmButtonText: "Registrar",
                        showLoaderOnConfirm: true,
                        html: `
                                      <label>Nombre completo</label>
                                      <input type="text" id="nombre_completo" class="form-control" placeholder="Nombre completo">
                                      <label>Teléfono</label>
                                      <input type="number" id="telefono" class="form-control" placeholder="Teléfono">`,
                        preConfirm: () => {
                          const nombre_completo =
                            Swal.getPopup().querySelector("#nombre_completo").value;
                          const telefono =
                            Swal.getPopup().querySelector("#telefono").value;
                          if (!nombre_completo || !telefono) {
                            Swal.showValidationMessage(
                              `Por favor registra el nombre y el teléfono`
                            );
                          }
                          return { nombre_completo, telefono };
                        },
                        allowOutsideClick: () => !Swal.isLoading(),
                      }).then(async (result) => {
                        if (!result.value) return;
                        const { nombre_completo, telefono } = result.value;
                        if (result.isConfirmed) {
                          // let resp = await postManiobrista({
                          //   nombre_completo,
                          //   telefono,
                          //   disponible: 1,
                          //   negocio_id: 1,
                          //   cedis_id: user.cedis_id,
                          // });

                          let resp = await postTripulantes({
                            "nombre_completo": nombre_completo,
                            "telefono": telefono,
                            "cedis_id": user.cedis_id,
                            "tipo_tripulante_id": 2,
                            "negocio_id": user.negocio_id,
                          });

                          // Continuar aquí
                          if (resp.tripulante_id) {
                            const arrayTripulacion = [...tripulacion];
                            if (tripulacion.length < 3) {
                              arrayTripulacion.push({
                                tripulante_id: resp.tripulante_id,
                              });
                            }

                            /*Trae los tripulantes para seleccionar */
                            let resp1 = await getListTripulantesByHub(
                              user.cedis_id,
                              2
                            );
                            if (resp1.ok) {
                              setListTripulantes(resp1.tripulante);
                            } else {
                              setListTripulantes([]);
                            }

                            if (tripulacion.length > 2) {
                              return Swal.fire({
                                title: "Se creó el tripulante",
                                text: "Se pudo crear pero no se pudo añadir a tu lista ya que solo se permite elegir 3 operadores, retira uno y selecciona el creado",
                                icon: "warning",
                              });
                            } else {
                              handleChange({
                                target: {
                                  name: "tripulacion",
                                  value: arrayTripulacion,
                                },
                              });

                              return Swal.fire({
                                title: `Tripulante creado con éxito`,
                                icon: "success",
                              });
                            }
                          }
                          return Swal.fire({
                            title: resp.msg,
                            icon: "error",
                          });
                        }
                      })
                    }
                  >
                    Registrar tripulante
                  </button>
                )}
              />
              {tripulacion.map((x) => {
                return (
                  <h1 className="mt-0">{pintarTripulante(x.tripulante_id)}</h1>
                );
              })}
            </div>
            <div className="modal-footer">
              <Button variant="secondary" data-bs-dismiss="modal" onClick={() => (limpiarDatos())}>
                Cancelar
              </Button>
              <Button variant="primary" data-bs-dismiss="modal" onClick={registrarAsignarUnidad}>
                Asignar
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};